<template>
  <div id="chart">
    <apexchart
      type="line"
      :height="graphHeight"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import get from 'lodash/get';
export default {
  name: 'LineChart',
  props: {
    assetGraphicData: {
      type: Array,
      required: true
    },
    graphicType: {
      type: String,
      required: true
    },
    startDate: {
      type: Date,
      required: false
    },
    endDate: {
      type: Date,
      required: false
    }
  },
  data() {
    return {
      series: [],
      graphHeight: 350
    };
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: this.graphHeight,
          type: 'line',
          toolbar: {
            show: true,
            zoomin: true,
            zoomout: true,
            download: true,
            zoom: true
          },
          zoom: {
            enabled: true
          }
        },
        tooltip: {
          x: {
            show: true,
            format: 'MMM dd HH:mm',
            formatter: undefined
          }
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: 'top',
          offsetY: -10,
          horizontalAlign: 'right'
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: this.graphicType,
          align: 'left',
          style: {
            fontSize: '20px',
            color: '#002835'
          }
        },
        grid: {
          row: {
            colors: ['#F3F3F3', 'transparent'],
            opacity: 0.5
          }
        },
        xaxis: {
          type: 'datetime',
          categories: get(this.assetGraphicData, '[0].dateList', []),
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'MMM dd',
              hour: 'HH:mm'
            }
          },
          min: this.dateMin,
          max: this.dateMax
        },
        yaxis: {
          decimalsInFloat: 2,
          tickAmount: this.tickAmount,
          min: this.measureMin,
          max: this.measureMax
        }
      };
    },

    dateMin() {
      let dateMin = Math.round(
        Math.min(...get(this.assetGraphicData, '[0].dateList', []))
      );
      for (const assetGraphicData of this.assetGraphicData) {
        const min = Math.round(Math.min(...assetGraphicData.dateList));
        if (min < dateMin) {
          dateMin = min;
        }
      }
      return dateMin;
    },

    dateMax() {
      let dateMax = Math.round(
        Math.max(...get(this.assetGraphicData, '[0].dateList', []))
      );
      for (const assetGraphicData of this.assetGraphicData) {
        const max = Math.round(Math.max(...assetGraphicData.dateList));
        if (max > dateMax) {
          dateMax = max;
        }
      }
      return dateMax;
    },

    measureMax() {
      let measureMax = Math.round(
        Math.max(...get(this.assetGraphicData, '[0].measureList', []))
      );
      for (const assetGraphicData of this.assetGraphicData) {
        const max = Math.round(Math.max(...assetGraphicData.measureList));
        if (max > measureMax) {
          measureMax = max;
        }
      }
      return measureMax + 1;
    },

    measureMin() {
      let measureMin = Math.round(
        Math.min(...get(this.assetGraphicData, '[0].measureList', []))
      );
      for (const assetGraphicData of this.assetGraphicData) {
        const min = Math.round(Math.min(...assetGraphicData.measureList));
        if (min < measureMin) {
          measureMin = min;
        }
      }
      return measureMin - 1;
    },

    tickAmount() {
      if (this.measureMax - this.measureMin > 10) {
        return 10;
      }
      return this.measureMax - this.measureMin;
    }
  },

  methods: {
    buildSeries() {
      for (let i = 0; i < this.assetGraphicData.length; i++) {
        this.series.push({
          name: `${this.assetGraphicData[i].type} ${this.assetGraphicData[i].reference}`,
          data: []
        });
        for (let j = 0; j < this.assetGraphicData[i].measureList.length; j++) {
          this.series[i].data.push({
            x: this.assetGraphicData[i].dateList[j],
            y: this.assetGraphicData[i].measureList[j]
          });
        }
      }
    }
  },

  watch: {
    assetGraphicData: {
      immediate: true,
      handler() {
        this.buildSeries();
      }
    }
  }
};
</script>
